import React, {useContext, useState, useEffect} from 'react';

import Ad from '~/src/components/ad/Ad';

import {AdFormat} from '~/src/utilities/constants/formats';
import {getAdUnitName, showAd} from '~/src/utilities/helpers/ad';
import {getNextCounter} from '~/src/utilities/helpers/counters';
import {SectionContext} from '~/src/components/context/SectionContext';
import {slugify} from '~/src/utilities/helpers/string';

const TeaserAd = (props) => {
    const section = useContext(SectionContext);
    const [renderAd, setRenderAd] = useState(false);

    process.browser &&
        useEffect(() => {
            setRenderAd(!props.availableFor || showAd(props.availableFor));
        }, []);

    if (!renderAd) {
        return null;
    }

    const ad = {...props};

    if (ad.format.primaryGrid === AdFormat.INSIDE_QUARTER_POS) {
        const adBase = section.subtype === 'category' ? `inside-quarter-${slugify(section.fullUrlPath)}` : `inside-quarter`;

        ad.adUnitName = getAdUnitName(adBase, getNextCounter(adBase));
    }

    if (!ad.adUnitName) {
        const adBase = section.subtype === 'category' ? `inside-full-${slugify(section.fullUrlPath)}` : `inside-full`;

        ad.adUnitName = getAdUnitName(adBase, getNextCounter(adBase));
        ad.format.primaryGrid = AdFormat.INSIDE_FULL_POS;
    }

    return <Ad {...ad} format={ad.format.primaryGrid} colorScheme={ad.format.colorScheme} />;
};

export default TeaserAd;
